import React from "react";
import { Place, Location } from "../types";

interface NavigationMapProps {
  places: Place[];
  setPlaceDetail: (place: Place | null) => void;
  placeDetail: Place | null;
  location: Location | null;
  setLocation: (location: Location | null) => void;
  user_id: string;
}

export default function NavigationMap({
  places,
  setPlaceDetail,
  placeDetail,
  location,
  setLocation,
  user_id,
}: NavigationMapProps) {
  return (
    <div style={{ padding: 16 }}>
      <h2>Navigation Map</h2>
      <p>Funkcionalita navigation map будет implementována позже</p>
    </div>
  );
}
